import { Environment } from '@campaign-portal/components-library';

export const environment: Environment = {
	production: true,
	version: '1.7.2-0.sha.783de81',
	releaseDate: '18 December 2025',

	protocol: '',
	host: '',
	port: '',
	api: 'api',
	localStorageKey: 'cp',
	configURL: `./assets/config.json?v=${new Date().getTime()}`,

	title: 'Alaris Labs',
	subTitle: 'Campaign Portal',

	theme: 'default',
	themeType: 'dark',

	termsUrl: '',
	privacyUrl: '',
	supportEmail: '',

	showLink: true,
	allowRegistration: true,

	systemTZOffset: 0,
	localTime: true,

	languagesID: ['en', 'es', 'tr'],

	is2FA: false,
	sessionTimeout: 60,
};
